import React, { useState } from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
export function Footer() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('submitting');
    try {
      const res = await fetch('https://formspree.io/f/mvzbdoqv', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          email
        })
      });
      if (res.ok) {
        setStatus('success');
        setEmail('');
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };
  return <footer className="bg-gray-900 text-white pt-16 pb-8 border-t border-gray-800" data-id="element-190">
      <div className="container mx-auto px-4" data-id="element-191">
        <div className="grid md:grid-cols-4 gap-12 mb-12" data-id="element-192">
          <div className="col-span-1 md:col-span-1" data-id="element-193">
            <div className="mb-6" data-id="element-194">
              <div className="flex items-center" data-id="element-195">
                <span className="text-xl font-bold text-slate-200 tracking-tight lowercase leading-none" data-id="element-196">
                  swedenmark
                </span>
                <div className="w-1.5 h-1.5 rounded-full bg-gradient-to-r from-blue-500 to-purple-500 mx-0.5 translate-y-[22%]" data-id="element-197"></div>
                <span className="text-xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-purple-500 lowercase leading-none" data-id="element-198">
                  ai
                </span>
              </div>
            </div>
            <p className="text-gray-400 mb-6 text-sm leading-relaxed" data-id="element-199">
              We catch the business slipping through the cracks and take the
              repetitive work off your team — built around how you actually run.
            </p>
          </div>

          <div data-id="element-200">
            <h3 className="text-sm font-bold uppercase tracking-wider text-gray-500 mb-6" data-id="element-201">
              Company
            </h3>
            <ul className="space-y-3" data-id="element-202">
              <li data-id="element-203">
                <a href="#about" className="text-gray-400 hover:text-white transition-colors" data-id="element-204">
                  About Us
                </a>
              </li>
              <li data-id="element-205">
                <a href="#services" className="text-gray-400 hover:text-white transition-colors" data-id="element-206">
                  Services
                </a>
              </li>
              <li data-id="element-207">
                <a href="#contact" className="text-gray-400 hover:text-white transition-colors" data-id="element-208">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-209">
            <h3 className="text-sm font-bold uppercase tracking-wider text-gray-500 mb-6" data-id="element-210">
              Services
            </h3>
            <ul className="space-y-3" data-id="element-211">
              <li data-id="element-212">
                <a href="#services" className="text-gray-400 hover:text-white transition-colors" data-id="element-213">
                  Get more business
                </a>
              </li>
              <li data-id="element-214">
                <a href="#services" className="text-gray-400 hover:text-white transition-colors" data-id="element-215">
                  Keep your customers happy
                </a>
              </li>
              <li data-id="element-216">
                <a href="#services" className="text-gray-400 hover:text-white transition-colors" data-id="element-217">
                  Run the back office on autopilot
                </a>
              </li>
              <li data-id="element-218">
                <a href="#pricing" className="text-gray-400 hover:text-white transition-colors" data-id="element-219">
                  Pricing
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-220">
            <h3 className="text-sm font-bold uppercase tracking-wider text-gray-500 mb-6" data-id="element-221">
              Stay Ahead
            </h3>
            <p className="text-gray-400 mb-4 text-sm" data-id="element-222">
              Practical notes on putting AI to work in your business — no hype.
            </p>
            {status === 'success' ? <div className="bg-green-900/40 border border-green-700 text-green-300 rounded-lg px-4 py-3 text-sm" data-id="element-223">
                ✓ You're on the list — thanks for subscribing!
              </div> : <form onSubmit={handleSubscribe} className="flex flex-col gap-2" data-id="element-224">
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Work email" required className="px-4 py-2 bg-gray-800 text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 border border-gray-700 text-sm" data-id="element-225" />
                <button type="submit" disabled={status === 'submitting'} className={`px-4 py-2 rounded-lg font-medium text-sm transition-colors ${status === 'submitting' ? 'bg-blue-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'} text-white`} data-id="element-226">
                  {status === 'submitting' ? 'Subscribing...' : 'Subscribe'}
                </button>
                {status === 'error' && <p className="text-red-400 text-xs" data-id="element-227">
                    Something went wrong. Please try again.
                  </p>}
              </form>}
          </div>
        </div>

        {/* Swedenmark Group Block */}
        <div className="border-t border-gray-800 pt-10 mb-10" data-id="element-228">
          <div className="text-xs font-semibold uppercase tracking-wider text-gray-500 mb-5" data-id="element-229">
            Part of the Swedenmark Group
          </div>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-230">
            <div className="bg-gray-800/40 border border-gray-800 rounded-xl p-5 flex items-center justify-between" data-id="element-231">
              <div data-id="element-232">
                <div className="flex items-center mb-1" data-id="element-233">
                  <span className="text-base font-bold text-slate-200 tracking-tight lowercase leading-none" data-id="element-234">
                    swedenmark
                  </span>
                  <div className="w-1 h-1 rounded-full bg-gradient-to-r from-blue-500 to-purple-500 mx-0.5 translate-y-[22%]" data-id="element-235"></div>
                  <span className="text-base font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-purple-500 lowercase leading-none" data-id="element-236">
                    ai
                  </span>
                </div>
                <p className="text-sm text-gray-400 mt-2" data-id="element-237">
                  AI automation & growth consulting
                </p>
                <p className="text-xs font-medium text-blue-400 mt-1.5 inline-flex items-center gap-1.5" data-id="element-238">
                  <span className="w-1.5 h-1.5 rounded-full bg-blue-500 animate-pulse" data-id="element-239"></span>
                  You are here
                </p>
              </div>
            </div>
            <a href="https://www.swedenmark.studio" target="_blank" rel="noopener noreferrer" className="group bg-gray-800/40 border border-gray-800 rounded-xl p-5 flex items-center justify-between hover:bg-gray-800/70 hover:border-gray-700 transition-all" data-id="element-240">
              <div data-id="element-241">
                <div className="flex items-center mb-1" data-id="element-242">
                  <span className="text-base font-bold text-slate-200 tracking-tight lowercase leading-none" data-id="element-243">
                    swedenmark
                  </span>
                  <div className="w-1 h-1 rounded-full bg-gradient-to-r from-blue-500 to-purple-500 mx-0.5 translate-y-[22%]" data-id="element-244"></div>
                  <span className="text-base font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-500 via-purple-500 to-rose-500 lowercase leading-none" data-id="element-245">
                    studio
                  </span>
                </div>
                <p className="text-sm text-gray-400 mt-2" data-id="element-246">
                  Custom software & product builds
                </p>
              </div>
              <span className="text-xs font-medium text-gray-300 group-hover:text-white inline-flex items-center gap-1 shrink-0 ml-4 transition-colors" data-id="element-247">
                swedenmark.studio
                <ArrowUpRightIcon size={14} data-id="element-248" />
              </span>
            </a>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-249">
          <p className="text-gray-500 text-sm" data-id="element-250">
            &copy; {new Date().getFullYear()} Swedenmark AI. All rights
            reserved.
          </p>
          <div className="flex space-x-6 text-sm text-gray-500" data-id="element-251">
            <a href="#" className="hover:text-white transition-colors" data-id="element-252">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-253">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}